import React from "react";
import NotificationsIcon from "@mui/icons-material/NotificationsOutlined";
import { Badge, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import clsx from "clsx";

export default function TopNavNotifications(props) {
  const {
    numNotifications,
    onExpandNotifications,
    notificationsIcon,
    active
  } = props;

  return (
    <IconButton
      aria-label="View Notifications"
      onClick={!active ? onExpandNotifications : undefined}
      className={clsx({ active: active })}
      data-qa="view-notifications-btn"
      size="large"
    >
      <Badge badgeContent={numNotifications} color="error">
        {notificationsIcon ? notificationsIcon : <NotificationsIcon />}
      </Badge>
    </IconButton>
  );
}

TopNavNotifications.propTypes = {
  numNotifications: PropTypes.number,
  notificationsIcon: PropTypes.node
};
